import React from "react";
import styled from "styled-components";

export default function CustomButton({ styles, ...props }) {
  return <Button styles={styles} {...props} />;
}

const Button = styled.button.attrs((props) => ({
  className:
    "bg-black text-white px-8 py-3 border-2 border-black rounded-2xl cursor-pointer" +
    props.styles,
}))``;
